export function usePrettyEthAddress(address: string): string {
	return `${address.slice(0, 5)}...${address.slice(
		address.length - 4,
		address.length
	)}`
}

export const etherscanUrl = (address: string | undefined) => {
	return `https://${
		`${
			process.env.REACT_APP_TEST_NETWORK
				? `${process.env.REACT_APP_TEST_NETWORK}.`
				: ''
		}` ?? ''
	}etherscan.io/address/${address ?? ''}`
}
